import type { BaseIconProps } from "@/assets/icons/geist/utils";
import type { FC } from "react";

export const IconEdit: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_467_866)">
                        <path
                            d="M12.587 5.40601C12.8514 5.14172 12.9999 4.78324 12.9999 4.40943C13 4.03563 12.8515 3.67711 12.5872 3.41276C12.323 3.1484 11.9645 2.99986 11.5907 2.99982C11.2169 2.99977 10.8584 3.14822 10.594 3.41251L3.921 10.087C3.80491 10.2028 3.71905 10.3453 3.671 10.502L3.0105 12.678C2.99758 12.7212 2.9966 12.7672 3.00767 12.8109C3.01875 12.8547 3.04146 12.8946 3.0734 12.9265C3.10533 12.9584 3.14531 12.981 3.18908 12.992C3.23285 13.003 3.27878 13.002 3.322 12.989L5.4985 12.329C5.65508 12.2814 5.79758 12.1961 5.9135 12.0805L12.587 5.40601Z"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M9.5 4.5L11.5 6.5"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_467_866">
                            <rect width="12" height="12" fill="white" transform="translate(2 2)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_467_870)">
                        <path
                            d="M15.3515 6.97366C15.6599 6.66533 15.8332 6.2471 15.8333 5.811C15.8333 5.37489 15.6601 4.95662 15.3518 4.64821C15.0435 4.33979 14.6252 4.1665 14.1891 4.16644C13.753 4.16639 13.3348 4.33958 13.0263 4.64792L5.24118 12.4348C5.10574 12.5699 5.00558 12.7361 4.94951 12.919L4.17893 15.4577C4.16385 15.5081 4.16271 15.5617 4.17563 15.6127C4.18855 15.6638 4.21505 15.7104 4.25231 15.7476C4.28957 15.7848 4.33621 15.8112 4.38727 15.824C4.43834 15.8369 4.49192 15.8357 4.54235 15.8205L7.0816 15.0505C7.26428 14.9949 7.43053 14.8954 7.56576 14.7606L15.3515 6.97366Z"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M11.75 5.91669L14.0833 8.25002"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_467_870">
                            <rect width="14" height="14" fill="white" transform="translate(3 3)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_467_874)">
                        <path
                            d="M18.116 8.54132C18.4685 8.18894 18.6665 7.71097 18.6666 7.21256C18.6666 6.71415 18.4687 6.23613 18.1163 5.88366C17.7639 5.53118 17.286 5.33313 16.7876 5.33307C16.2892 5.33301 15.8111 5.53094 15.4587 5.88332L6.56133 14.7827C6.40654 14.937 6.29207 15.127 6.228 15.336L5.34733 18.2373C5.3301 18.295 5.3288 18.3562 5.34356 18.4146C5.35833 18.4729 5.38861 18.5261 5.43119 18.5687C5.47378 18.6112 5.52708 18.6414 5.58544 18.656C5.64379 18.6707 5.70504 18.6693 5.76266 18.652L8.66466 17.772C8.87344 17.7085 9.06345 17.5947 9.218 17.4407L18.116 8.54132Z"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M14 7.33331L16.6667 9.99998"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_467_874">
                            <rect width="16" height="16" fill="white" transform="translate(4 4)" />
                        </clipPath>
                    </defs>
                </svg>
            );
    }
};
